import React from "react";
import { Link } from "react-router-dom";

const BtnAddSimulation = () => {
  return (
    <Link to="/client/simulation/new" className="btn">
      Faire une demande
    </Link>
  );
};

export default BtnAddSimulation;
